export default __webpack_public_path__ + "static/media/browser.7a0444c9.svg";